import { useRef, useState } from 'react';
import styled from 'styled-components';
import { Trans } from '@lingui/react';
import Button from '@components/buttons';
import Input2 from '@components/form/Input2';
import Label from '@components/form/Label';
import { Box, Flex } from '@components/layout/Grid';

const InputGroup = styled.div`
  button {
    height: 100%;
  }
`;

type Props = {
  title: React.ReactNode;
  value: string;
  disabled?: boolean;
};

export const CopyInputGroup = (props: Props) => {
  const { title, value, disabled = false } = props;
  const [copied, setCopied] = useState(false);
  const _textInputRef = useRef<HTMLInputElement>();

  const handleCopy = () => {
    if (!disabled) {
      _textInputRef.current.select();
      document.execCommand('copy');
      _textInputRef.current.blur();
      setCopied(true);
    }
  };

  return (
    <InputGroup data-testid="ShareModal--URLInput">
      <Box mb="7px">
        <Label htmlFor="shareModalCode">{title}</Label>
      </Box>
      <Flex>
        <Box flex="1">
          <Input2
            id="shareModalCode"
            ref={_textInputRef}
            type="text"
            readOnly={true}
            value={value}
            onClick={handleCopy}
          />
        </Box>
        <Box>
          <Button borderRadiuslessLeft onClick={handleCopy} disabled={disabled}>
            {copied ? (
              <Trans id="share_modal.copied_button" message={'Copied !'} />
            ) : (
              <Trans
                id="settings_referall.personal_code_action"
                message="Copy"
              />
            )}
          </Button>
        </Box>
      </Flex>
    </InputGroup>
  );
};
